import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { BASE_URL } from './helper';


export default function Post() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    // const [updateUI, setUpdateUI] = useState(true);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/post`); // replace with your API endpoint
                const jsonData = await response.json();
                setData(jsonData);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);

    const formatDate = (inputDate) => {
        const dateObj = new Date(inputDate);
        const day = dateObj.getDate();
        const month = dateObj.getMonth() + 1;
        const year = dateObj.getFullYear() % 100;
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year.toString().padStart(2, '0')}`;
    }

    const onClickEdit = (postId) => {
        navigate(`/updatepost/${postId}`); // Pass postId as a parameter in URL
    }

    const onClickRead = (postId) => {
        navigate(`/singlepost/${postId}`); // Pass postId as a parameter in URL
    }

    const onClickDelete = async (postId) => {
        try {
            const response = await fetch(`${BASE_URL}/api/deleteblog/${postId}` , {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                // Handle successful delete
                console.log("Post deleted successfully");
                alert("Post deleted successfully");
                // Refresh data after deleting
                const newData = data.filter(post => post._id !== postId);
                setData(newData);
            }
        } catch (error) {
            // Handle fetch error
            console.log("Error deleting post:", error);
            alert("Failed to delete post. Please try again.");
        }
    }

    return (
        <div className='container post-container cont-1'>
            <div className='row'>
                {loading ? (
                    <>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card">
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card" >
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-3'>
                            <div className="card mt-5 skeleton-card" >
                                <Skeleton height={200} />
                                <div className="card-body">
                                    <Skeleton height={20} width={150} />
                                    <Skeleton height={80} count={2} />
                                    <div className='card-title'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                    <div className='card-text'>
                                        <Skeleton height={20} width={150} />
                                        <Skeleton height={80} count={2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    data.map((post) => (
                        <div key={post._id} className='col-sm-12 col-md-6 col-lg-3'>
                            <div className="card mt-5" >
                                <div className="card-body">
                                    <img src={post.imageUrl} className="card-img-top" alt="..." />
                                    <h5 className="card-title pt-2 d-inline-block">{post.title}</h5>
                                    <p className="card-text">{post.description.substring(0, 100) + " ..."}<button className='read-btn' onClick={() => onClickRead(post._id)}>Read more</button></p>
                                    <div className='author-info d-flex'>
                                        <Link className='name' to='#'>Marilou Kelleher</Link>
                                        <time className='date'>{formatDate(post.date)}</time> {/* Format date here */}
                                    </div>
                                    <span className='update'>
                                        <button onClick={() => onClickEdit(post._id)}>Edit</button> {/* Pass post id to onClickEdit */}
                                    </span>
                                    <span className='delet'>
                                        <button onClick={() => onClickDelete(post._id)}>Delete</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
